import { render, staticRenderFns } from "./JSONOutput.vue?vue&type=template&id=2d2616a4&scoped=true"
import script from "./JSONOutput.vue?vue&type=script&lang=js"
export * from "./JSONOutput.vue?vue&type=script&lang=js"
import style0 from "./JSONOutput.vue?vue&type=style&index=0&id=2d2616a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2616a4",
  null
  
)

export default component.exports